import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsMenuModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

import { ChatService } from '../../../../coaching-base/chat.service';
import { CmpsCoachingTagsModule } from '../../../../coaching-tags/coaching-tags.module';
import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';
import { CmpsCoachingClickOutsideModule } from '../directive/click-outside.module';

import { ChatBoxComponent } from './chat-box.component';
import { TranslationIdMap } from './chat-box.i18n';

@NgModule({
    declarations: [ChatBoxComponent],
    exports: [ChatBoxComponent],
    imports: [
        CmpsButtonModule,
        CmpsCheckboxModule,
        CmpsCoachingClickOutsideModule,
        CmpsCoachingTagsModule,
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMenuModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        PickerModule,
        ReactiveFormsModule,
    ],
    providers: [ChatService],
})
export class CmpsCoachingChatBoxModule {}
